import React from "react";
import { useLang } from "@/lib/i18n";

const KEY = "lp_cookie_consent_v1";

export default function CookieBanner() {
  const { t } = useLang();
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setShow(true);
  }, []);

  const save = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-40" data-testid="cookie-banner">
      <div className="lp-card p-5">
        <div className="text-sm font-medium text-white/90">{t("cookie.title")}</div>
        <p className="text-white/60 text-sm mt-2">{t("cookie.body")}</p>
        <div className="mt-4 flex flex-col md:flex-row gap-2">
          <button onClick={() => save("all")} className="lp-btn-primary text-sm py-2 justify-center flex-1" data-testid="cookie-accept-all">
            {t("cookie.accept_all")}
          </button>
          <button onClick={() => save("necessary")} className="lp-btn-secondary text-sm py-2 justify-center flex-1" data-testid="cookie-only-necessary">
            {t("cookie.only_necessary")}
          </button>
        </div>
      </div>
    </div>
  );
}
